import React from 'react';
import { Link } from 'react-router-dom';
import { Icon, IconifyIcon } from '@iconify/react';
import calendar from '@iconify/icons-solar/calendar-linear';
import documentAdd from '@iconify/icons-solar/document-add-linear';
import arrowLeft from '@iconify/icons-solar/arrow-left-linear';
import arrowRight from '@iconify/icons-solar/arrow-right-linear';
import checklist from '@iconify/icons-solar/checklist-minimalistic-linear';
import refresh from '@iconify/icons-solar/refresh-linear';
import info from '@iconify/icons-solar/info-circle-linear';
import './workflow.css';

export const workflowIcons = { calendar, documentAdd, arrowLeft, arrowRight, checklist, refresh, info };
type Variant = 'primary' | 'secondary' | 'ghost';

export function WorkflowLink({ to, children, icon, variant = 'secondary', ...rest }: {
  to: string; children: React.ReactNode; icon?: IconifyIcon; variant?: Variant;
} & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>) {
  return <Link {...rest} to={to} className={`workflow-control workflow-control--${variant} ${rest.className || ''}`}>
    {icon && <Icon icon={icon} width={18} aria-hidden="true" />}<span>{children}</span>
  </Link>;
}

export function WorkflowButton({ children, icon, variant = 'primary', ...rest }: {
  children: React.ReactNode; icon?: IconifyIcon; variant?: Variant;
} & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button type="button" {...rest} className={`workflow-control workflow-control--${variant} ${rest.className || ''}`}>
    {icon && <Icon icon={icon} width={18} aria-hidden="true" />}<span>{children}</span>
  </button>;
}

export default function WorkflowHeader({ title, description, actions, navigation }: {
  title: string; description: string; actions?: React.ReactNode; navigation?: React.ReactNode;
}) {
  return <header className="workflow-heading">
    <div className="workflow-heading-row"><div className="workflow-heading-copy"><h1>{title}</h1><p>{description}</p></div>
      {actions && <div className="workflow-actions">{actions}</div>}
    </div>
    {navigation && <nav className="workflow-navigation" aria-label="Related workflows">{navigation}</nav>}
  </header>;
}
